<div class="col-lg login-container">
    <div class="logo" aria-label="noovle">
        <img src="assets/img/logo_noovle.svg" class="" alt="logo" />
    </div>
    <span class="col-lg title">
        Noovle JIRA Orchestrator
    </span>
    <span class="btn-wrapper" style="margin-top: 20px;">
        <!--<div id="googleBtn"></div>-->
        <div id="microsoftBtn"><img src="assets/img/msSignIn.png" (click)="avviaLoginPopup()" class="msLogin"/></div>
    </span>

    <div class="logoCmyk" aria-label="noovle">
        <img src="assets/img/logo_tim.svg" class="" alt="logo" />
    </div>
</div>